export const PASSWORD_VALIDATION_TYPES = {
    ONE_LOWERCASE: {
        key: 'oneLowercase'
    },
    ONE_UPPERCASE: {
        key: 'oneUppercase'
    },
    ONE_SYMBOL: {
        key: 'oneSymbol'
    },
    ONE_NUMBER: {
        key: 'oneNumber'
    },
    MIN_LENGTH_8_CHAR: {
        key: 'minLength'
    },
    CONFIRMATION_MATCH: {
        key: 'confirmationMatch'
    }
};
const PASSWORD_VALIDATION = [
    {
        validate: (password, context) => {
            const { createError } = context;
            const error = createError({ message: PASSWORD_VALIDATION_TYPES.ONE_LOWERCASE.key });
            if (!password) return error;

            const regex = new RegExp(/[a-z]+/g);
            const matches = regex.exec(password);
            if (matches && matches.length > 0) return true;

            return error;
        }
    },
    {
        validate: (password, context) => {
            const { createError } = context;
            const error = createError({ message: PASSWORD_VALIDATION_TYPES.ONE_UPPERCASE.key });
            if (!password) return error;

            const regex = new RegExp(/[A-Z]+/g);
            const matches = regex.exec(password);
            if (matches && matches.length > 0) return true;

            return error;
        }
    },
    {
        validate: (password, context) => {
            const { createError } = context;
            const error = createError({ message: PASSWORD_VALIDATION_TYPES.ONE_SYMBOL.key });
            if (!password) return error;

            const regex = new RegExp(/[^a-zA-Z\d\s:]+/g);
            const matches = regex.exec(password);
            if (matches && matches.length > 0) return true;

            return error;
        }
    },
    {
        validate: (password, context) => {
            const { createError } = context;
            const error = createError({ message: PASSWORD_VALIDATION_TYPES.ONE_NUMBER.key });
            if (!password) return error;

            const regex = new RegExp(/[0-9]+/g);
            const matches = regex.exec(password);
            if (matches && matches.length > 0) return true;

            return error;
        }
    },
    {
        validate: (password, context) => {
            const { createError } = context;
            const error = createError({ message: PASSWORD_VALIDATION_TYPES.MIN_LENGTH_8_CHAR.key });
            if (!password) return error;

            if (password.length >= 8) return true;

            return error;
        }
    }
];

//  runs through each password validation step and produces a validation error if one was returned from the validator
export const validatePassword = (password, context) => {
    const { createError } = context;

    //  maps the validators results or returns null which will be filtered out
    const errors = PASSWORD_VALIDATION.map((validator) => {
        const result = validator.validate(password, context);
        if (result && result.message) return result.message;
        return null;
    }).filter(Boolean); //  removes null results

    if (errors.length === 0) return true;

    //  joins all valdation messages to be used by a consumer, i.e. PasswordRules
    return createError({ message: errors.join(',') });
};

//  validates that both passwords match
export const validateConfirmPassword = (confirmPassword, context) => {
    const { createError, parent } = context;
    const { password } = parent;
    const error = createError({ message: PASSWORD_VALIDATION_TYPES.MIN_LENGTH_8_CHAR.key });

    if (confirmPassword !== password) return error;

    return true;
};
